/* Tysk katalog for locale-autopilot-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'ap.review.completed': 'Geprüft / genehmigt',
  'ap.review.reviewApproved': 'Prüfung genehmigt',
  'ap.review.approvedNotBooked': 'Genehmigt · wartet auf Buchung',
  'ap.review.booked': 'Gebucht',
  'ap.review.checked': 'Geprüft',
  'ap.review.queueError': 'Die Aufgabenliste konnte nicht aktualisiert werden. Die Übersicht ist möglicherweise unvollständig. Versuche es erneut, bevor du Vorschläge bearbeitest.',
  'ap.review.retry': 'Erneut versuchen',
  'ap.review.overduePeriods': '{{count}} Fristen sind überschritten',
  'ap.review.overduePeriod': '1 Frist ist überschritten',
  'ap.review.overdueDetails': 'Überfällige Folgepunkte: {{count}}. Einreichung: {{submissions}}. Zahlung: {{payments}}.',
  'ap.review.deadlinePoints': '{{overdue}} überfällige und {{upcoming}} anstehende Folgepunkte',
  'ap.review.missingStatements': 'Kontoauszüge fehlen',
  'ap.review.missingStatementsPeriod': 'Für diese Konten fehlt der Kontoauszug für {{period}}.',
  'ap.monthControl.liveTitle': 'Laufender Monat',
  'ap.monthControl.liveBlockedReason': 'Der Monat läuft noch. Du kannst Zeilen laufend bearbeiten und genehmigen, der Abschluss ist aber erst nach Monatsende möglich.',
  'ap.cancelEntry': 'Buchung stornieren',
  'ap.saveEntry': 'Buchung speichern',
  'ap.suggestion': 'Vorschlag von SuperPlumma',
  'ap.amountIncVat': 'Betrag (inkl. MwSt.)',
  'ap.saveCorrection': 'Korrektur speichern',
  'ap.correct': 'Korrigieren',
  'ap.openInPayroll': 'Im Lohn öffnen',
  'ap.payrollLines': 'Lohnzeilen',
  'ap.hoursCount': 'Anzahl Stunden',
  'ap.hourlyRate': 'Stundensatz',
  'ap.monthlyGross': 'Monatslohn (brutto)',
  'ap.holidayPayAccrued': 'Urlaubsgeld zurückgestellt (12 %)',
  'ap.employerCosts': 'Arbeitgeberkosten',
  'ap.employerContribution': 'Arbeitgeberabgabe (14,1 %)',
  'ap.mandatoryPension': 'Verpflichtende betriebliche Altersvorsorge (2 %)',
  'ap.approveAndFile': 'Genehmigen und einreichen',
  'ap.vatReturnTitle': 'MVA-melding (MwSt.-Erklärung)',
  'ap.post': 'Posten',
  'ap.checkPost': 'Posten prüfen',
  'ap.allPostsChecked': 'Alle Posten wurden geprüft.',
  'ap.registerAsset': 'Vermögenswert erfassen',
  'ap.backToAssets': 'Zurück zu den Vermögenswerten',
  'ap.confirmAsset': 'Vermögenswert bestätigen',
  'ap.registeredAutomatically': 'Automatisch erfasst',
  'ap.balanceGroup': 'Saldogruppe',
  'ap.amountExVat': 'Betrag (exkl. MwSt.)',
  'ap.registeredFrom': 'Erfasst aus',
  'ap.registeredAssets': 'Erfasste Vermögenswerte',
  'ap.approveRegistrations': 'Erfassungen genehmigen',
  'ap.saveAllAndApprove': 'Alle speichern und genehmigen',
  'ap.skip': 'Überspringen',
  'ap.skipped': 'Übersprungen',
  'ap.amountIncVatShort': 'Betrag inkl. MwSt.',
  'ap.openVoucherFull': 'Beleg in voller Größe öffnen',
  'ap.security': 'Sicherheit',
  'ap.dragVoucherHere': 'Ziehe einen Beleg aus dem Posteingang hierher',
  'ap.approve': 'Genehmigen',
  'ap.dragVoucherOntoLine': 'Ziehe einen Beleg auf die Zeile, mit der du ihn verknüpfen möchtest.',
  'ap.approveTask': 'Aufgabe genehmigen',
  'ap.sent': 'Gesendet',
  'ap.sentCount': '{{count}} gesendet',
  'ap.openVatReturn': 'MVA-melding öffnen',
  'ap.openTask': 'Aufgabe öffnen',
  'ap.reopenTask': 'Genehmigung rückgängig machen',
  'ap.rerun': 'Erneut durchsehen',
  'ap.rerunHelp': 'Lädt die Warteschlange erneut aus Functions und baut die Agentenliste neu auf. Es wird nichts gebucht oder genehmigt.',
  'ap.rerunDone': 'AI Buchhalter hat {{month}} erneut durchgesehen.',
  'ap.rerunFailed': 'Die Durchsicht konnte nicht erneut ausgeführt werden.',
  'ap.staleApproval': 'Genehmigt am {{date}} · die Grundlage hat sich seitdem geändert',
  'ap.bankConnection': 'Bankverbindung',
  'ap.agent.invoice.title': '{{count}} Rechnung(en) nicht gesendet',
  'ap.agent.invoice.titleDone': 'Alle Rechnungen wurden gesendet',
  'ap.agent.invoice.desc': '{{drafts}} sind Entwürfe und {{unsent}} sind fertig, aber nicht gesendet.',
  'ap.agent.invoice.descDone': 'Keine Entwürfe oder ungesendeten Rechnungen in {{year}}.',
  'ap.agent.invoice.detail': 'Ein Entwurf ist weder als Ertrag erfasst noch an den Kunden gesendet. Senden und Buchen erfolgen in der Rechnungsliste.',
  'ap.agent.invoice.action': 'Rechnungsliste öffnen',
  'ap.agent.invoice.lineDraft': 'Entwurf · nicht als Ertrag erfasst',
  'ap.agent.invoice.lineUnsent': 'Fertig, aber nicht gesendet',
  'ap.agent.invoice.execute': '{{count}} Rechnungen senden',
  'ap.agent.invoice.choose': 'Rechnungen auswählen',
  'ap.agent.invoice.selectAll': 'Alle sendefähigen auswählen',
  'ap.agent.invoice.selectRow': 'Rechnung auswählen',
  'ap.agent.invoice.selectedCount': '{{count}} ausgewählt',
  'ap.agent.invoice.sendableCount': '{{count}} sendefähig',
  'ap.agent.invoice.finishDraftFirst': 'Entwürfe müssen fertiggestellt werden, bevor sie gesendet werden können',
  'ap.agent.invoice.sendSelectedOne': 'Ausgewählte Rechnung senden',
  'ap.agent.invoice.sendSelected': '{{count}} ausgewählte Rechnungen senden',
  'ap.agent.invoice.executeDone': 'Rechnungen gesendet',
  'ap.agent.dunning.title': '{{count}} überfällige Rechnung(en) warten auf eine Mahnung',
  'ap.agent.dunning.titleDone': 'Keine überfälligen Rechnungen',
  'ap.agent.dunning.desc': '{{amount}} kr sind nach Fälligkeit offen.',
  'ap.agent.dunning.descDone': 'Alle gesendeten Rechnungen sind noch nicht fällig oder bezahlt.',
  'ap.agent.dunning.detail': 'Mahnungen, Mahngebühren und Verzugszinsen werden aus der Rechnungsliste gesendet. AI Buchhalter sendet nichts selbstständig.',
  'ap.agent.dunning.action': 'Rechnungsliste öffnen',
  'ap.agent.dunning.line': 'Seit {{days}} Tag(en) überfällig · Rechnung {{num}}',
  'ap.agent.dunning.execute': '{{count}} Zahlungserinnerungen senden',
  'ap.agent.dunning.executeTitle': 'Zahlungserinnerungen senden',
  'ap.agent.dunning.executeWarn': 'Die Erinnerungen gehen direkt an deine Kunden und können nicht zurückgerufen werden. Auch Kunden, die gerade bezahlt haben, ohne dass die Zahlung erfasst ist, erhalten eine.',
  'ap.agent.dunning.executeNote': 'Plumme mahnt dieselbe Rechnung höchstens alle sieben Tage und überspringt Rechnungen, die beglichen sind oder keine Kunden-E-Mail haben.',
  'ap.agent.dunning.executeDone': 'Erinnerungen gesendet',
  'ap.agent.inbox.title': '{{count}} Beleg(e) im Posteingang nicht gebucht',
  'ap.agent.inbox.titleDone': 'Der Posteingang ist leer',
  'ap.agent.inbox.desc': '{{ready}} sind buchungsbereit und {{review}} müssen geprüft werden.',
  'ap.agent.inbox.descAnalyzing': '{{count}} Beleg(e) werden noch gelesen.',
  'ap.agent.inbox.descDone': 'Keine Belege warten auf Bearbeitung.',
  'ap.agent.inbox.detail': 'Belege werden beim Eingang automatisch gelesen. Buchung und Kontenwahl werden im Posteingang genehmigt.',
  'ap.agent.inbox.action': 'Posteingang öffnen',
  'ap.agent.inbox.execute': '{{count}} bereite Belege buchen',
  'ap.agent.inbox.executeDone': 'Belege gebucht',
  'ap.agent.inbox.voucher': 'Beleg',
  'ap.agent.inbox.lineReady': 'Gelesen und buchungsbereit',
  'ap.agent.inbox.lineReview': 'Muss vor der Buchung geprüft werden',
  'ap.agent.reconcile.title': '{{count}} Monat(e) nicht abgestimmt',
  'ap.agent.reconcile.titleDone': 'Alle abgeschlossenen Monate sind abgestimmt',
  'ap.agent.reconcile.descEarly': 'In {{year}} ist noch kein Monat abgeschlossen.',
  'ap.agent.reconcile.desc': '{{closed}} von {{total}} abgeschlossenen Monaten sind abgestimmt und gebucht.',
  'ap.agent.reconcile.descDone': 'Das Geschäftskonto ist bis einschließlich Vormonat abgestimmt.',
  'ap.agent.reconcile.detail': 'Ein Monat gilt als abgestimmt, wenn der Auszug des Geschäftskontos gebucht und in Bank archiviert ist. Die Abstimmung muss chronologisch erfolgen.',
  'ap.agent.reconcile.action': 'Bank öffnen',
  'ap.agent.reconcile.titleBlockedOrder': '{{month}} muss zuerst abgestimmt werden',
  'ap.agent.reconcile.descBlockedOrder': 'Die Abstimmung erfolgt chronologisch. Der Anfangssaldo stammt aus dem Vormonat, eine Abweichung dort bliebe hier unsichtbar.',
  'ap.agent.reconcile.detailBlockedOrder': 'Gehe zu Bank und schließe den ältesten nicht abgestimmten Zeitraum ab. Dann wird dieser Monat automatisch freigegeben.',
  'ap.agent.reconcile.reasonBlockedOrder': 'Wartet auf {{month}}',
  'ap.agent.reconcile.line': 'Kein abgestimmter Geschäftskontoauszug',
  'ap.agent.quality.title': '{{count}} Befund(e) in der Qualitätsprüfung',
  'ap.agent.quality.titleDone': 'Keine Befunde in der Qualitätsprüfung',
  'ap.agent.quality.desc': '{{missing}} Einkäufe ohne Beleg und {{duplicates}} möglicherweise doppelt gebucht.',
  'ap.agent.quality.descDone': 'Alle Einkäufe in {{year}} haben einen Beleg, und es wurden keine möglichen Doppelbuchungen gefunden.',
  'ap.agent.quality.detailVat': 'Einkäufe ohne Beleg machen {{vat}} kr an Vorsteuerabzug aus, der bei einer Prüfung abgelehnt werden kann.',
  'ap.agent.quality.detail': 'Mögliche Doppelbuchungen sind Einkäufe mit demselben Lieferanten, Betrag und Datum. Sie müssen manuell beurteilt werden, bevor etwas storniert wird.',
  'ap.agent.quality.action': 'Transaktionen öffnen',
  'ap.agent.quality.purchase': 'Einkauf',
  'ap.agent.quality.lineDuplicate': '{{count}} Buchungen mit demselben Lieferanten, Betrag und Datum',
  'ap.agent.quality.lineMissing': 'Beleg fehlt · öffne den Einkauf, um Dokumentation hochzuladen oder zu verknüpfen',
  'ap.agent.deadline.titleOverdue': '{{count}} Frist(en) überschritten',
  'ap.agent.deadline.title': '{{count}} Frist(en) rücken näher',
  'ap.agent.deadline.titleDone': 'Keine Fristen in den nächsten 30 Tagen',
  'ap.agent.deadline.desc': 'Die nächste Frist ist {{name}} {{date}}.',
  'ap.agent.deadline.descOverdue': '{{count}} überfällige Abgabe(n) noch offen.',
  'ap.agent.deadline.descDone': 'Alle Abgaben mit Frist innerhalb von 30 Tagen sind eingereicht.',
  'ap.agent.deadline.lineNotFiled': 'Überfällig · nicht eingereicht',
  'ap.agent.deadline.lineNotPaid': 'Überfällig · nicht als bezahlt markiert',
  'ap.agent.deadline.detail': 'Die Fristen richten sich nach dem MwSt.-Zeitraum und der Rechtsform des Unternehmens. Die Einreichung erfolgt unter Abgaben.',
  'ap.agent.deadline.action': 'Abgaben öffnen',
  'ap.agent.deadline.lineOverdue': 'Seit {{days}} Tag(en) überfällig',
  'ap.agent.deadline.line': 'Noch {{days}} Tag(e)',
  'ap.agent.annualDeadline.subjectMany': '{{count}} Abgaben',
  'ap.agent.annualDeadline.titleDone': 'Die Fristen im {{month}} sind erledigt',
  'ap.agent.annualDeadline.titleOverdue': '{{subject}} ist nicht eingereicht — die Frist ist abgelaufen',
  'ap.agent.annualDeadline.title': '{{subject}} ist im {{month}} fällig',
  'ap.agent.annualDeadline.desc': '{{name}} für {{year}} ist am {{date}} fällig.',
  'ap.agent.annualDeadline.descDone': 'Alle Abgaben mit Frist im {{month}} sind als eingereicht markiert.',
  'ap.agent.annualDeadline.detail': 'Die Frist liegt im Jahr nach dem Einkommensjahr, daher betrifft dies den Abschluss für {{year}} — nicht {{calendarYear}}. Diese Zeile blockiert die Freigabe des Monats nicht.',
  'ap.agent.annualDeadline.action': 'Öffnen',
  'ap.agent.annualDeadline.lineFiled': 'Als eingereicht markiert',
  'ap.agent.annualDeadline.execute': 'Als außerhalb von Plumme eingereicht markieren',
  'ap.agent.annualDeadline.executeTitle': 'Aksjonærregisteroppgave als eingereicht markieren',
  'ap.agent.annualDeadline.executeWarn': 'Plumme sendet nichts. Es wird nur vermerkt, dass die Meldung anderswo eingereicht wurde, damit die Frist nicht mehr warnt.',
  'ap.agent.annualDeadline.executeNote': 'Die Aksjonærregisteroppgave (RF-1086) wird über ein Endbenutzersystem oder Altinn eingereicht. Wohnungsbaugesellschaften sind ausgenommen, und Gesellschaften, für die Euronext VPS die Meldung abgibt, reichen nicht selbst ein.',
  'ap.agent.annualDeadline.executeDone': 'markiert',
  'ap.agent.annualDeadline.statusDetail': '{{subject}} muss im Jahresabschluss-Workflow bearbeitet werden.',
  'ap.agent.mileage.title': '{{count}} Fahrtenbuchfahrten ohne Dokumentation',
  'ap.agent.mileage.titleOk': '{{count}} Fahrtenbuchfahrten sind dokumentiert',
  'ap.agent.mileage.titleEmpty': 'Keine Fahrten in {{year}} erfasst',
  'ap.agent.mileage.desc': 'Das Fahrtenbuch ergibt {{amount}} kr Abzug in {{year}}.',
  'ap.agent.mileage.descEmpty': 'Dienstfahrten sind abzugsfähig, aber nur, wenn jede Fahrt mit Datum, Strecke, Zweck und Kilometern erfasst ist.',
  'ap.agent.mileage.detail': 'Ein Fahrtenbuch muss für jede Fahrt Datum, Start und Ziel, Zweck und Kilometer zeigen. Fahrten ohne diese Angaben können abgelehnt werden.',
  'ap.agent.mileage.action': 'Fahrtenbuch öffnen',
  'ap.agent.mileage.trip': 'Fahrt ohne Strecke',
  'ap.agent.mileage.lineNoPurpose': 'Zweck fehlt',
  'ap.agent.mileage.lineNoKm': 'Kilometer fehlen',
  'ap.agent.mileage.lineNoRoute': 'Strecke fehlt',
  'ap.agent.match.title': '{{count}} Bankzeilen ohne Beleg',
  'ap.agent.match.titleDone': 'Alle Bankzeilen haben einen Beleg',
  'ap.agent.match.desc': '{{count}} Belege im Posteingang könnten passen.',
  'ap.agent.match.descDone': 'Keine Bankzeilen ohne Dokumentation.',
  'ap.agent.match.detail': 'Ein Beleg wird nur automatisch verknüpft, wenn er genau zu einer Bankzeile passt und diese genau zu einem Beleg. Im Zweifel wählst du selbst.',
  'ap.agent.match.action': 'Bank öffnen',
  'ap.agent.match.line': 'Beleg fehlt',
  'ap.agent.match.execute': 'Belege automatisch verknüpfen',
  'ap.agent.match.executeTitle': 'Belege mit Bankzeilen verknüpfen',
  'ap.agent.match.executeWarn': 'Die Belege werden als Dokumentation an die Bankzeilen angehängt. Es wird nichts gebucht — das geschieht erst beim Abgleich des Kontoauszugs.',
  'ap.agent.match.executeNote': 'Nur eindeutige Treffer werden verknüpft: Der Beleg muss zu einer Bankzeile passen und die Bankzeile zu einem Beleg. Alles andere bleibt zur manuellen Auswahl.',
  'ap.agent.match.executeDone': 'Belege verknüpft',
  'ap.agent.contacts.supplier': 'Lieferanten',
  'ap.agent.contacts.customer': 'Kunden',
  'ap.agent.contacts.title': 'Bis zu {{count}} {{noun}} fehlen im Register',
  'ap.agent.contacts.titleDone': 'Alle {{noun}} sind erfasst',
  'ap.agent.contacts.desc': 'Namen, die in der Buchhaltung wiederholt vorkommen, aber nicht im Register stehen.',
  'ap.agent.contacts.descDone': 'Keine wiederkehrenden Namen außerhalb des Registers.',
  'ap.agent.contacts.detail': 'Es werden nur Name und Organisationsnummer angelegt. E-Mail, Telefon und Adresse trägst du selbst ein — Plumme rät keine Kontaktdaten, die auf einer Rechnung landen könnten.',
  'ap.agent.contacts.openSuppliers': 'Lieferanten öffnen',
  'ap.agent.contacts.openCustomers': 'Kunden öffnen',
  'ap.agent.contacts.line': '{{count}} Buchungen',
  'ap.agent.contacts.execute': 'Fehlende {{noun}} anlegen',
  'ap.agent.contacts.executeTitle': '{{noun}} im Register anlegen',
  'ap.agent.contacts.executeWarn': 'Die Namen werden im Register angelegt. Bestehende Buchungen werden nicht automatisch verknüpft — das machst du beim Öffnen des Eintrags.',
  'ap.agent.contacts.executeNote': 'Plumme legt nur Namen an, die mindestens zweimal vorkommen, und überspringt Zahlungstexte wie „Visa“ und „Vipps“.',
  'ap.agent.contacts.executeDone': 'angelegt',
  'ap.contact.supplierNumber': 'Lieferantennr.',
  'ap.contact.supplierNumberPh': 'z. B. 20001',
  'ap.contact.supplierName': 'Lieferantenname',
  'ap.contact.customerName': 'Kundenname',
  'ap.contact.namePh': 'Name',
  'ap.contact.customerNamePh': 'z. B. Beispiel AS',
  'ap.contact.org': 'Org.-Nummer',
  'ap.contact.orgOptional': 'Org.-Nummer (optional)',
  'ap.contact.orgPh': '123 456 789',
  'ap.contact.supplierEmailPh': 'faktura@leverandor.no',
  'ap.contact.customerEmailPh': 'post@eksempel.no',
  'ap.contact.phonePh': '400 00 000',
  'ap.contact.address': 'Adresse',
  'ap.contact.addressPh': 'Straße und Hausnummer',
  'ap.contact.supplierAddressPh': 'Straße, PLZ und Ort',
  'ap.agent.tax.titleBlocked': 'Die Steuerbemessungsgrundlage ist nicht verfügbar',
  'ap.agent.tax.descBlocked': 'Die Buchhaltungszahlen für {{year}} sind nicht geladen.',
  'ap.agent.tax.detail': 'Die Einreichung der skattemelding erfordert die Altinn-Integration, die noch nicht angebunden ist.',
  'ap.agent.tax.blocked': 'Buchhaltungszahlen fehlen',
  'ap.agent.tax.titleDone': 'Die skattemelding für {{year}} ist eingereicht',
  'ap.agent.tax.title': 'Die Steuerbemessungsgrundlage für {{year}} ist berechnet',
  'ap.agent.tax.descEnk': 'Ergebnis vor Steuern: {{result}} kr. Ein Einzelunternehmen wird beim Inhaber besteuert.',
  'ap.agent.tax.desc': 'Ein Ergebnis vor Steuern von {{result}} kr ergibt {{tax}} kr berechnete Steuer.',
  'ap.agent.tax.action': 'skattemelding öffnen',
  'ap.agent.tax.lineResult': 'Ergebnis vor Steuern',
  'ap.agent.tax.lineTax': 'Berechnete Steuer',
  'ap.agent.tax.lineLoss': 'Verlustvortrag',
  'ap.agent.annual.titleBlocked': 'Der Jahresabschluss ist nicht verfügbar',
  'ap.agent.annual.descBlocked': 'Die Buchhaltungszahlen für {{year}} sind nicht geladen.',
  'ap.agent.annual.blocked': 'Buchhaltungszahlen fehlen',
  'ap.agent.annual.titleNotRequired': 'Das Unternehmen ist nicht zum Jahresabschluss verpflichtet',
  'ap.agent.annual.descNotRequired': 'Ein Einzelunternehmen reicht stattdessen die næringsspesifikasjon mit der skattemelding ein.',
  'ap.agent.annual.action': 'Jahresabschluss öffnen',
  'ap.agent.annual.stepDocument': 'Jahresabschlussdokument',
  'ap.agent.annual.stepBoard': 'Vorstandsprotokoll',
  'ap.agent.annual.stepAssembly': 'Protokoll der Hauptversammlung',
  'ap.agent.annual.stepSigned': 'Unterzeichnung',
  'ap.agent.annual.titleDone': 'Der Jahresabschluss für {{year}} ist eingereicht',
  'ap.agent.annual.title': '{{count}} Schritte im Jahresabschluss für {{year}} offen',
  'ap.agent.annual.titleReady': 'Der Jahresabschluss für {{year}} ist bereit zur Einreichung',
  'ap.agent.annual.descClosed': 'Das Geschäftsjahr ist abgeschlossen.',
  'ap.agent.annual.descOpen': 'Das Geschäftsjahr ist noch nicht abgeschlossen.',
  'ap.agent.annual.detail': 'Die Einreichung beim Regnskapsregisteret erfordert die Altinn-Integration, die noch nicht angebunden ist.',
  'ap.agent.annual.line': 'Nicht abgeschlossen',
  'ap.execute.title': 'Über AI Buchhalter buchen',
  'ap.execute.running': 'Wird gebucht …',
  'ap.execute.warnTitleGeneric': 'Das kann nicht rückgängig gemacht werden',
  'ap.execute.warnTitle': 'Damit wird in deiner Buchhaltung gebucht',
  'ap.execute.warnBody': 'Die Belege werden als Einkäufe mit Konto, MwSt. und Zahlungsart aus der Beleganalyse gebucht. Du bist dafür verantwortlich, dass die Buchungen korrekt sind, und musst sie manuell stornieren, falls etwas falsch ist.',
  'ap.execute.checked': 'Plumme prüft jeden Beleg erneut, bevor er gebucht wird. Belege, die die Prüfung nicht bestehen, bleiben mit einer Begründung im Posteingang.',
  'ap.execute.doneCount': '{{booked}} {{noun}}',
  'ap.execute.done': '{{booked}} Belege gebucht',
  'ap.execute.partialCount': '{{done}} {{skipped}} wurden nicht ausgeführt und müssen nachverfolgt werden.',
  'ap.execute.failed': 'Die Buchung wurde nicht durchgeführt.',
  'ap.lastRun': 'Zuletzt geprüft {{when}}',
  'ap.lastRunLabel': 'Zuletzt geprüft',
  'ap.bankDataHelp': 'SuperPlumma verwendet die Kontoauszüge, die du unter Bank importiert hast. Eine direkte Bankanbindung gibt es noch nicht – lade einen Kontoauszug als XLSX oder CSV hoch, damit die Bankzeilen übernommen werden.',
  'ap.bankData': 'Bankdaten',
  'ap.bankStatementImported': 'Kontoauszug importiert',
  'ap.noBankData': 'Kein Kontoauszug importiert',
  'ap.noData': 'Keine Daten',
  'ap.importBankStatement': 'Kontoauszug importieren',
  'ap.loadingTitle': 'Deine Buchhaltung wird geladen …',
  'ap.loadingText': 'SuperPlumma wartet auf Daten aus deiner Buchhaltung. Die Aufgabenliste erscheint, sobald die Zahlen geladen sind.',
  'ap.disconnectBank': 'Bank trennen',
  'ap.connected': 'Verbunden',
  'ap.noBankConnected': 'Keine Bank verbunden',
  'ap.connectBankHelp': 'Verbinde deine Bank, damit SuperPlumma Banktransaktionen buchen kann.',
  'ap.bankIdNote': 'Die Verbindung erfolgt sicher mit BankID.',
  'ap.missingBasis': 'Grundlage fehlt',
  'ap.rowDescMissing': 'Es fehlen Informationen, bevor AI Buchhalter weiterarbeiten kann.',
  'ap.rowBlockedReasonDefault': 'Erfordert Einrichtung oder Daten',
  'ap.rowOpen': 'Öffnen',
  'ap.working': 'Wird bearbeitet …',
  'ap.execute.queued': 'In die Warteschlange gestellt. Wird ausgeführt, auch wenn du die Seite schließt – du wirst benachrichtigt, wenn sie fertig ist.',
  'ap.execute.queueFailed': 'Die Aktion konnte nicht in die Warteschlange gestellt werden.',
  'ap.job.done': '{{booked}} ausgeführt.',
  'ap.job.donePartial': '{{booked}} ausgeführt · {{skipped}} wurden nicht ausgeführt und müssen nachverfolgt werden.',
  'ap.job.failed': 'Die Aktion wurde nicht durchgeführt.',
  'ap.waiting': 'Wartet',
  'ap.waitingDetail': 'Kann noch nicht bearbeitet werden',
  'ap.waitingGroup.title': '{{count}} Agenten warten',
  'ap.waitingGroup.titleOne': '{{agent}} wartet',
  'ap.waitingGroup.detail': 'Werden relevant, sobald der Zeitraum bereit ist',
  'ap.oneLineNeedsControl': ' Zeile muss geprüft werden',
  'ap.manyLinesNeedControl': ' Zeilen müssen geprüft werden',
  'ap.readyHere': '{{count}} bereit',
  'ap.openWorklist': 'Arbeitsliste öffnen',
  'ap.controlWorklist': 'Arbeitsliste prüfen',
  'ap.controlTask': 'Prüfen',
  'ap.openPage': 'Seite öffnen',
  'ap.waitsForPrevious': 'Wartet',
  'ap.nextStep': 'Nächster Schritt',
  'ap.comeBackLater': 'Später wiederkommen',
  'ap.solveBlocker': 'Blockierung lösen',
  'ap.getBankData': 'Bankdaten abrufen',
  'ap.approved': 'Genehmigt',
  'ap.whichAgents': 'Welche Agenten möchtest du aktivieren?',
  'ap.allAgents': 'Alle Agenten',
  'ap.settings.enabledCount': '{{on}} von {{total}} aktiv',
  'ap.settings.intro': 'SuperPlumma und die Agenten arbeiten laufend an deiner Buchhaltung. Wähle, welche Agenten dir helfen sollen. Du kannst die Einstellungen jederzeit ändern. Arbeiten, die nicht aktiviert sind, musst du selbst manuell erledigen.',
  'ap.settings.allHelp': 'Alle auf einmal aktivieren oder deaktivieren.',
  'ap.permission.inbox.label': 'Posteingangsagent',
  'ap.permission.inbox.desc': 'Liest Quittungen und Rechnungen, die per E-Mail oder Upload eingehen, und bereitet sie für die Buchung vor.',
  'ap.permission.matching.label': 'Belegagent',
  'ap.permission.matching.desc': 'Ordnet Belege aus dem Posteingang Bankzeilen ohne Dokumentation zu, wenn die Zuordnung eindeutig ist.',
  'ap.permission.reconciliation.label': 'Abstimmungsagent',
  'ap.permission.reconciliation.desc': 'Sorgt dafür, dass jeder abgeschlossene Monat tatsächlich mit dem Geschäftskonto abgestimmt und gebucht ist.',
  'ap.permission.control.label': 'Kontrollagent',
  'ap.permission.control.desc': 'Sucht nach Einkäufen ohne Beleg und möglichen Doppelbuchungen in der Buchhaltung.',
  'ap.permission.asset.label': 'Anlagenagent',
  'ap.permission.asset.desc': 'Schlägt bei größeren Einkäufen ein Anlagegut vor. Du wählst sofortigen Aufwand oder Abschreibungsgruppe, bevor derselbe Beleg einmal gebucht wird.',
  'ap.permission.vendor.label': 'Lieferantenagent',
  'ap.permission.vendor.desc': 'Legt neue Lieferanten an, wenn SuperPlumma wiederholte Buchungen vom selben Lieferanten erkennt.',
  'ap.permission.customer.label': 'Kundenagent',
  'ap.permission.customer.desc': 'Legt neue Kunden an, wenn SuperPlumma Verkäufe an unbekannte Kunden erkennt.',
  'ap.permission.invoice.label': 'Rechnungsagent',
  'ap.permission.invoice.desc': 'Verfolgt Rechnungsentwürfe und fertige Rechnungen, die noch nicht an den Kunden gesendet wurden.',
  'ap.permission.dunning.label': 'Mahnagent',
  'ap.permission.dunning.desc': 'Behält überfällige Rechnungen im Blick und zeigt, was zuerst gemahnt werden sollte.',
  'ap.permission.deadline.label': 'Fristenagent',
  'ap.permission.deadline.desc': 'Warnt vor Abgabefristen, die bald ablaufen oder überschritten sind.',
  'ap.permission.mileage.label': 'Fahrtenbuchagent',
  'ap.permission.mileage.desc': 'Prüft, ob Geschäftsfahrten mit Strecke, Zweck und Kilometern erfasst sind, damit der Abzug Bestand hat.',
  'ap.permission.vat.label': 'MwSt.-Agent',
  'ap.permission.vat.desc': 'Stimmt die MwSt. ab und bereitet die MVA-melding zur Übermittlung vor.',
  'ap.permission.tax.label': 'Steueragent',
  'ap.permission.tax.desc': 'Füllt die skattemelding auf Basis deiner Buchhaltung vorab aus.',
  'ap.permission.payroll.label': 'Lohnagent',
  'ap.permission.payroll.desc': 'Behält Lohnläufe im Blick, die auf Genehmigung warten. Berechnung und Genehmigung erfolgen im Lohnbereich.',
  'ap.permission.annual.label': 'Jahresabschlussagent',
  'ap.permission.annual.desc': 'Bereitet Jahresabschluss und Anhang beim Jahresabschluss vor.',
  'ap.beta': 'Beta',
  'ap.heroTitle': 'SuperPlumma erledigt die Arbeit – du behältst die Kontrolle.',
  'ap.heroSub': 'Sieh, was noch offen ist, prüfe Vorschläge und genehmige den nächsten Schritt.',
  'ap.aboutHelp': 'SuperPlumma sammelt Aufgaben und bereitet Vorschläge aus verfügbaren Daten vor. Buchen und Senden erfordern deine Genehmigung. Der Schalter steuert die automatische Prüfung, nicht Übermittlung oder Zahlung.',
  'ap.enabledDescription': 'SuperPlumma prüft deine Buchhaltung jeden Morgen und sammelt, was ansteht. Wähle, welche Bereiche die Agenten prüfen sollen. Nichts wird ohne deine Genehmigung gebucht oder gesendet.',
  'ap.disabledDescription': 'Der Autopilot ist aus. Schalte ihn ein, damit SuperPlumma deine Buchhaltung im Hintergrund prüft.',
  'ap.monthOpenHelp': 'SuperPlumma bereitet im Laufe des Monats fortlaufend Vorschläge vor. Einige Schritte warten, bis der Zeitraum bereit ist, aber alles wird automatisch aktualisiert, wenn neue Grundlagen eingehen.',
  'ap.monthControl.label': 'Monatskontrolle',
  'ap.monthControl.permissionDesc': 'Bearbeitet Bankzeilen, Belege, Geschäftspartner und mögliche Anlagegüter und stimmt den Monat in einem gemeinsamen Arbeitsablauf ab.',
  'ap.monthControl.blockedDesc': 'Die Bankgrundlage fehlt. Belege ohne Bankzeile können weiterhin bearbeitet werden.',
  'ap.monthControl.actionableDesc': 'Offene Punkte in {{period}}: {{count}}. Bankzeilen, Belege, Geschäftspartner, Anlagegüter und Abstimmung werden gemeinsam bearbeitet.',
  'ap.monthControl.doneDesc': 'Die Monatskontrolle für {{period}} ist abgeschlossen.',
  'ap.monthControl.title': 'Monatskontrolle für **{{period}}**',
  'ap.monthControl.detail': 'Bearbeite Bankzeilen chronologisch, verknüpfe Belege, lege fehlende Geschäftspartner an und prüfe mögliche Anlagegüter im selben Arbeitsbereich. Die Genehmigung ist umkehrbar; die endgültige Buchung erfolgt weiterhin mit „Abstimmen und buchen“.',
  'ap.monthControl.waitingDetail': 'Die Periode läuft noch — es können noch neue Zeilen hinzukommen',
  'ap.monthControl.blockedReason': 'Kontoauszug oder Bankabdeckung fehlt',
  'ap.monthControl.action': 'Monatskontrolle öffnen',
  'ap.monthControl.findingsEmpty': 'Keine möglichen Abweichungen.',
  'ap.monthControl.finding.deviation': 'Mögliche Abweichung',
  'ap.monthControl.finding.missingVoucher': 'Beleg fehlt',
  'ap.monthControl.finding.needsReview': 'Muss vor dem Abgleich geprüft werden.',
  'ap.monthControl.count.inboxOne': '{{count}} Beleg im Posteingang',
  'ap.monthControl.count.inboxMany': '{{count}} Belege im Posteingang',
  'ap.monthControl.count.bankMissingVoucherOne': '{{count}} Bankzeile ohne Beleg',
  'ap.monthControl.count.bankMissingVoucherMany': '{{count}} Bankzeilen ohne Beleg',
  'ap.monthControl.count.bankLineOne': '{{count}} Bankzeile',
  'ap.monthControl.count.bankLineMany': '{{count}} Bankzeilen',
  'ap.monthControl.count.reconciliationOne': '{{count}} Abgleich',
  'ap.monthControl.count.reconciliationMany': '{{count}} Abgleiche',
  'ap.monthControl.count.qualityOne': '{{count}} Befund in der Qualitätskontrolle',
  'ap.monthControl.count.qualityMany': '{{count}} Befunde in der Qualitätskontrolle',
  'ap.monthControl.count.assetOne': '{{count}} Vermögenswert',
  'ap.monthControl.count.assetMany': '{{count}} Vermögenswerte',
  'ap.monthControl.count.supplierOne': '{{count}} Lieferant',
  'ap.monthControl.count.supplierMany': '{{count}} Lieferanten',
  'ap.monthControl.count.customerOne': '{{count}} Kunde',
  'ap.monthControl.count.customerMany': '{{count}} Kunden',
  'ap.monthControl.count.itemOne': '{{count}} Punkt',
  'ap.monthControl.count.itemMany': '{{count}} Punkte',
  'ap.monthControl.noDate': 'Ohne Datum',
  'ap.monthControl.action.paySupplierInvoice': 'Lieferantenrechnung bezahlen',
  'ap.monthControl.action.registerSupplierInvoice': 'Lieferantenrechnung erfassen',
  'ap.monthControl.action.invoicePayment': 'Rechnungszahlung',
  'ap.monthControl.action.registerSale': 'Verkauf erfassen',
  'ap.monthControl.action.registerPurchase': 'Einkauf erfassen',
  'ap.monthControl.block.needsControl': 'Der Beleg muss vor dem Buchen geprüft werden.',
  'ap.monthControl.block.missingBookingType': 'Buchungsart fehlt.',
  'ap.monthControl.block.missingInvoiceNumber': 'Rechnungsnummer fehlt.',
  'ap.monthControl.block.lowConfidence': 'Geringe Sicherheit der Analyse.',
  'ap.monthControl.block.manualReview': 'Der Beleg erfordert eine manuelle Prüfung.',
  'ap.monthControl.edit.purchase': 'Einkauf ändern',
  'ap.monthControl.edit.sale': 'Verkauf ändern',
  'ap.monthControl.edit.bankFee': 'Gebühr ändern',
  'ap.monthControl.edit.invoicePayment': 'Rechnungszahlung ändern',
});
